import { translatedObjectStore } from '~/shared/helpers/translation'

const paymentTranslationsKeys: Record<string, string> = {
  priceSettingBuyTitle: 'buy',
  priceSettingRentTitle: 'rent',
  priceSettingButtonText: 'buy',
  priceSettingRentButtonText: 'rent',
  priceSettingAddCardButtonTitle: 'add_card',
  confirmPaymentButtonTitle: 'confirm_payment',
  successPurchaseConfirmationTitle: 'success_purchase',
  authFormCardNumberTitle: 'card_number',
  authFormExpiryDateTitle: 'expiry_date',
  authFormPlaceholderMonthTitle: 'auth_form_month',
  authFormPlaceholderYearTitle: 'auth_form_year',
  authFormSecurityCodeTitle: 'security_code',
  authFormSecurityCodeSubTitle: 'security_code_hint',
  authFormPlaceholderCvvTitle: 'security_code',
  authFormRememberCardTitle: 'remember_card',
}

export const $payment = translatedObjectStore(paymentTranslationsKeys)
